export default {
  menuVisible: false,
  loadingOverlay: false,
  feedback: null,
  automationsAdvancedView: true,
  automationsAdvancedViewChanged: false,
  windowSizes: {
    width: 0,
    height: 0
  },
  isDark: true,
  initializing: false,
  backendError: 0,
  clientFingerprint: '',
  usageId: '',
  automationRunDelayOptions: [
    0,
    60,
    120,
    300,
    600,
    900,
    1200,
    1800,
    2400,
    2700,
    3600
  ],
  cameraSmallViewSnapshotInterval: 2,
  cameraViewSnapshotInterval: 1,
  googleMapsBaseUrl: 'https://maps.googleapis.com/maps/api/js',
  googleMapsApiKey: '',
  googleMapsLibLoaded: false,
  isMobileUserAgent: false,
  geolocationSupported: false,
  geolocation: null,
  system: null,
  versions: {
    app: '1',
    engine: '1',
    ui: '1'
  }
};
